<template>
  <f7-panel id="right-panel-root"
    class="showSmallScreenOnly"
    side="right"
    effect="cover"
    layout="layout-white"
    theme="white"
    :opened="isOpen"
    @panel:opened="isOpen = true"
    @panel:closes="isOpen = false">
    <div class="navbar">
      <div class="navbar-inner no-swipeback">
        <div class="left" style="padding-left:10px">
          <i class="icon imgClosePanel" @click="isOpen = false" :class="imgCross"/>
          <p style="padding-left:10px">{{ pageTitle }}</p>
        </div>
      </div>
    </div>
    <RightPanelFilterView v-if="feature === 'filter-messages'" :serviceId="serviceId"/>
  </f7-panel>
</template>

<script>
import RightPanelFilterView from '@/components/common/Filter/RightPanelFilterView'
import design from '@/design/design.json'

export default {
  name: 'RightPanel',
  components: {
    RightPanelFilterView
  },
  data () {
    return {
      feature: '',
      isOpen: false,
      pageTitle: '',
      serviceId: 1,
      design: design.menu
    }
  },
  computed: {
    imgCross () {
      if (this.design && this.design.headbandColor && this.design.headbandColor.length >= 7) {
        var c = this.design.headbandColor.substring(1)
        var rgb = parseInt(c, 16)
        var r = (rgb >> 16) & 0xff
        var g = (rgb >> 8) & 0xff
        var b = (rgb >> 0) & 0xff

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        if (luma < 40) {
          return 'icon-cross_white'
        } else {
          return 'icon-cross'
        }
      }
      return 'icon-cross'
    }
  },
  created () {
    if (this.$engine.user.currentService) {
      this.serviceId = this.$engine.user.currentService.id.toString()
    }
    // Panel open/close events
    this.$bus.on('right-panel-open', (serviceId) => {
      this.serviceId = serviceId
      this.isOpen = false
      setTimeout(() => {
        this.isOpen = true
      }, 100)
    })
    this.$bus.on('right-panel-close', () => {
      this.isOpen = true
      setTimeout(() => {
        this.isOpen = false
      }, 100)
    })
    this.$bus.on('right-panel-toggle', () => {
      this.isOpen = !this.isOpen
    })

    // Feature events
    this.$bus.on('right-panel-set-feature', (feature) => {
      this.feature = feature
      this.pageTitle = this.$root.$t('filter.title_fltr')
    })
    this.$bus.on('right-panel-clear-feature', () => {
      this.feature = ''
      this.pageTitle = ''
    })
  },
  methods: {
    isWhite () {
      if (this.design.headbandTextColor.length >= 7) {
        var c = this.design.headbandTextColor.substring(1)
        var rgb = parseInt(c, 16)
        var r = (rgb >> 16) & 0xff
        var g = (rgb >> 8) & 0xff
        var b = (rgb >> 0) & 0xff

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        if (luma < 40) {
          return './../../assets/static/images/icons/white_cross.png'
        } else {
          return './../../assets/static/images/icons/black_cross.png'
        }
      }
    }
  }
}
</script>

<style scoped>
#right-panel-root {
  max-width:75%;
  min-width:75%;
  height:inherit;
  background-color:white;
  border:none;
  box-shadow: -1px 0px 5px grey;
  overflow: hidden;
}
#right-panel-filter-view {
  overflow-x: hidden;
  overflow-y: auto;
}
@media (max-width: 992px) {
  #right-panel-filter-view {
    margin-top: -44px;
    padding-top: 44px;
  }
}
@media (min-width: 993px) {
  #right-panel-filter-view {
    margin-top: -100px;
    padding-top: 100px;
  }
}
.imgClosePanel {
  width: 32px;
  height:32px;
  margin-top:auto;
  margin-bottom:auto;
  float:right;
}
.navbar {
  background-color: var(--headbandColor);
  color: var(--headbandTextColor);
}
</style>
